var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbol2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.75 0.5C60.4062 0.5 63.5 3.59375 63.5 7.25V56.75C63.5 60.5469 60.4062 63.5 56.75 63.5H7.25C3.45312 63.5 0.5 60.5469 0.5 56.75V7.25C0.5 3.59375 3.45312 0.5 7.25 0.5H56.75ZM52.25 35.9375V28.0625C52.25 27.2188 51.4062 26.375 50.5625 26.375H37.625V13.4375C37.625 12.5938 36.7812 11.75 35.9375 11.75H28.0625C27.0781 11.75 26.375 12.5938 26.375 13.4375V26.375H13.4375C12.4531 26.375 11.75 27.2188 11.75 28.0625V35.9375C11.75 36.9219 12.4531 37.625 13.4375 37.625H26.375V50.5625C26.375 51.5469 27.0781 52.25 28.0625 52.25H35.9375C36.7812 52.25 37.625 51.5469 37.625 50.5625V37.625H50.5625C51.4062 37.625 52.25 36.9219 52.25 35.9375Z",
    fill: "#5E2866"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbol2);
export default __webpack_public_path__ + "static/media/Symbol (2).19e680477146e5e9fd0520db47f52d2f.svg";
export { ForwardRef as ReactComponent };